import {listen, fire} from "../utils/events";
import Utils from "../utils";
import Splash from "../splash/splash";
import SlideManager from "../utils/slide-manager";
import CooboAudio from './cooboAudio.js';
import getTabIndex from "../utils/tab-index";
import Transition from "../2DObjects/Transition";

function initAudio() {
    listen('audioInitialized', () => {
        playBackgroundAudio();
        playSlideAudio();
    });
    listen('slidechange', () => {
        if (!Q3.editMode && Q3.backgroundAudio.src && Q3.backgroundAudio.duration !== Q3.backgroundAudio.currentTime) {
             Q3.backgroundAudio.play();
        }
        playSlideAudio();
    });
    listen('langchanged', playSlideAudio);

    SlideManager.activeSlideAudio = new CooboAudio();
    SlideManager.activeSlideAudio.addEventListener("loadedmetadata", initAudioPlayer);

    const setAnalyticsData = (e) => {
        Q3.Analytics.add({type: 'audioevent',
            eventName: e.type,
            duration: SlideManager.activeSlideAudio.duration,
            audioTime: SlideManager.activeSlideAudio.currentTime,
            audioName: SlideManager.activeSlideAudio.name
        })
    };
    ["abort", "ended", "pause", "play", "seeked"].forEach(eventName => {
        SlideManager.activeSlideAudio.addEventListener(eventName, setAnalyticsData)
    });

    Q3.backgroundAudio = new CooboAudio();
    Q3.currentAudioKey = "audio";


}

const onEnded = () => {
    Q3.mediaIsPlaying.splice(Q3.mediaIsPlaying.indexOf(SlideManager.activeSlideAudio._audio), 1);
    !Q3.mediaIsPlaying.length && fire("mediaEnded", SlideManager.activeSlideAudio.duration);
    SlideManager.activeSlideAudio.removeEventListener('ended', onEnded);
};

function playSlideAudio() {
    if (!Splash.isRemoved) return;

    SlideManager.activeSlideAudio.removeEventListener('ended', onEnded);

    if (Q3.data.slides[SlideManager.prevSlide] && (Q3.data.slides[SlideManager.prevSlide].audioThisSlideOnly ||
        SlideManager.activeSlide < SlideManager.prevSlide)) {
        // console.log("pause");
        SlideManager.activeSlideAudio._audio.setAttribute("src", "");
    }
    let audiokey = SlideManager.currentSlide[Q3.currentAudioKey] ? Q3.currentAudioKey : "audio";

    if (!Q3.editMode) {
        playAudio(SlideManager.activeSlideAudio, SlideManager.currentSlide[audiokey], {}, () => {
            SlideManager.activeSlideAudio.addEventListener('ended', onEnded);
            Q3.mediaIsPlaying.push(SlideManager.activeSlideAudio);
        });
    }

    // if (SlideManager.currentSlide[audiokey]) {
    //
    // }

}


function playBackgroundAudio() {
    if (!Splash.isRemoved) return;

    playAudio(Q3.backgroundAudio, Q3.data.audio, {
        loop: Q3.editMode || Q3.data.setups.loopAudio !== false,
    });
    if (Q3.editMode) {
        Q3.backgroundAudio.pause();
    }
}

function stopBackgroundAudio() {
    Q3.backgroundAudio.currentTime = 0;
    Q3.backgroundAudio.pause();
}

function playAudio(player, audioUuid, {loop = false} = {}, callback) {

    let volume = player.volume;

    if (audioUuid && Q3.data.assets.audio[audioUuid]) {
        let audioData = Q3.data.assets.audio[audioUuid];
        volume = 'volume' in audioData ? audioData.volume : 0.6;
        player.initialVolume = volume;
        player.loop = Boolean(loop);
        player.src = Q3.data.assets.audio[audioUuid].fullPath || Q3.s3Url + Q3.data.assets.audio[audioUuid].path;
        player.play().then(() => {
            if (Q3.teachMode === "student"
              && Q3.SlideManager.currentSlide.uuid === Utils.queryParams.get("slide")
              && Q3.resumeTimestamp) {
                player.currentTime = Q3.resumeTimestamp;
            }
            player.volume = volume;

            const action = Q3.data.assets.audio[audioUuid].action
            if (!Q3.editMode && action && action[0]) {
                action.forEach(currAction => {
                    if (currAction.userAction === "timeplayed") {
                        const transition = new Transition(currAction.systemAction, currAction.value);
                        transition.addTimePlayedAction(player, currAction.timePlayed)
                    }
                })
            }
            typeof callback === "function" && callback();
        });
    }
}

function initAudioPlayer() {
    let player = Q3.SlideManager.activeSlideAudio;
    if ($("#audio-player").length) {
        $("#audio-player").fadeIn();
        $("#audio-player .total-time").html(Utils.secondsToString(player.duration));
        return;
    }
    let playerEl = $(`<div id="audio-player"></div>`);
    let theme = Q3.SlideManager.currentSlide.audioPlayerTheme || "mute";
    let playerTheme = $(`<div id="player-theme" class="${theme}"><div class="drag-handle"></div></div>`);
    playerEl.append(playerTheme);
    let restartBtn = $(`<div class="player-btn restart disabled" tabindex="${getTabIndex()}"></div>`);
    restartBtn.on("click", () => {
        player.currentTime = 0;
        restartBtn.addClass("disabled");
    })
    let playpauseBtn = $(`<div id="playpause" class="player-btn pause" tabindex="${getTabIndex()}"></div>`);
    playpauseBtn.on("click", () => {
        let paused = SlideManager.activeSlideAudio.paused;
        SlideManager.activeSlideAudio[paused ? "play" : "pause"]();
    })
    let playerSlider = $(`<div class="player-slider" tabindex="${getTabIndex()}"></div>`);

    function onKeyDown(e) {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            e.stopPropagation();
        } else {
            return
        }
        let direction = e.key === 'ArrowLeft' ? -1 : 1;
        let targetTime = player.currentTime + player.duration / 100 * 5 * direction;
        if (targetTime < 0) {
            targetTime = 0;
        }
        if (targetTime > player.duration) {
            targetTime = player.duration;
        }
        player.currentTime = targetTime;

    }

    playerSlider.on("focus", () => {
        window.addEventListener('keydown', onKeyDown);
    });
    playerSlider.on("blur", () => {
        window.removeEventListener('keydown', onKeyDown);
    });
    let playedBar = $(`<div class="played"></div>`);
    playerSlider.append(playedBar);
    let scrubber = $(`<div class="scrubber"></div>`);
    let scrubberIndicator = $(`<div class="indicator">0:00</div>`);
    scrubber.append(scrubberIndicator);
    playerSlider.append(scrubber);
    playerSlider.append($(`<div class="loaded"></div>`));
    let playerTime = $(`<div class="player-time"></div>`);
    let currentTime = $(`<span class="current-time">0:00</span>`);
    let totalTime = $(`<span class="total-time">${Utils.secondsToString(player.duration)}</span>`);
    playerTime.append(currentTime, $(`<span> / </span>`), totalTime);

    let muteBtn = $(`<div id="mute-btn" class='material-icons player-btn'>volume_up</div>`);
    let muted = false;
    muteBtn.on('click', (e) => {
        muted = !muted;
        Q3.backgroundAudio.volume = muted ? 0 : Q3.backgroundAudio.initialVolume ? Q3.backgroundAudio.initialVolume : 0.6;
        SlideManager.activeSlideAudio.volume = muted ? 0 : SlideManager.activeSlideAudio.initialVolume ? SlideManager.activeSlideAudio.initialVolume : 0.6;
        muteBtn.html(muted ? 'volume_off' : 'volume_up');
        Q3.Analytics.add({ type: `${muted ? "mute" : "unmute"}`})
    });
    playerTheme.append(restartBtn, playpauseBtn, playerSlider, playerTime, muteBtn);

    player.addEventListener("timeupdate", updateProgressAndDisplay);
    player.addEventListener("play", () => {
        playpauseBtn[0].className = "player-btn pause";
    });
    player.addEventListener("pause", () => {
        playpauseBtn[0].className = "player-btn play";
    });

    let mouseDownWidth = 0;
    let x = 0;
    scrubber.on("mousedown", (e) => {
        x = e.clientX;
        scrubber.addClass("dragging");
        mouseDownWidth = playedBar.width() / playerSlider.width() * 100;
        $(document).on("mousemove", scrubberOnMouseMove)
    });
    $(document).on("mouseup", () => {
        $(document).off("mousemove", scrubberOnMouseMove, false);
        scrubber.removeClass("dragging");
    });

    function scrubberOnMouseMove(e) {
        let delta = e.clientX - x;
        let value = Math.min(100, mouseDownWidth + delta / playerSlider.width() * 100);
        player.currentTime = player.duration / 100 * value;
    }

    function updateProgressAndDisplay() {
        restartBtn[player.currentTime ? "removeClass" : "addClass"]("disabled");
        let time = Utils.secondsToString(player.currentTime);
        scrubberIndicator[0].innerHTML = currentTime[0].innerHTML = time;
        playedBar.css("width", player.currentTime / player.duration * 100 + "%");
    }

    $("#app").append(playerEl);
    playerTheme.draggable({
        containment: "#audio-player",
        handle: ".drag-handle",
        scroll: false
    });

    listen('slidechange', () => {
        $("#audio-player").hide();
        $("#audio-player #player-theme")[0].className = Q3.SlideManager.currentSlide.audioPlayerTheme || "mute";
    });

}

export default initAudio;
export {initAudio};
